import { render } from "./VabeneUpsellSettingsPage.vue?vue&type=template&id=7526443a&ts=true"
import script from "./VabeneUpsellSettingsPage.vue?vue&type=script&lang=ts"
export * from "./VabeneUpsellSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__